import { render, staticRenderFns } from "./BookSummaryMiniSkelton.vue?vue&type=template&id=c95aa6ee&scoped=true&"
var script = {}
import style0 from "./BookSummaryMiniSkelton.vue?vue&type=style&index=0&id=c95aa6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95aa6ee",
  null
  
)

export default component.exports